import * as AT from '../constants/actionTypes'

/**
 * Targetgroup reducer
 * @param {*} state 
 * @param {*} action 
 */
function targetgroup(state = { targetgroups: [] }, action) {
	switch (action.type) {
		case AT.TARGETGROUP_LIST_LOADING_STARTED:
			return Object.assign({}, state, {
				isLoading: true,
				targetgroups: [],
				error: undefined
			})
		case AT.TARGETGROUP_LIST_LOADING_FAILED:
			return Object.assign({}, state, {
				isLoading: false,
				error: action.payload.error
			})
		case AT.TARGETGROUP_LIST_LOADING_FINISHED:
			return Object.assign({}, state, {
				isLoading: false,
				targetgroups: action.payload.targetgroups,
				error: undefined
			})			
		default:
			return state;
	}
}

export default targetgroup;